import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.5
const Tiles = [
  {
    thumbnail_path: "/assets/images/gallery/placeholder/1-1.jpg",
    path: "/assets/images/gallery/1-1.jpg",
    position: {
      x: 0 + Start,
      y: 0.4
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "A MAJOR NEW DEVELOPMENT FOR ZONE 1",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/1-2.jpg",
    path: "/assets/images/gallery/1-2.jpg",
    position: {
      x: 2.2 + Start,
      y: -0.1
    },
    title: {
      label:
        "Postmark has all the buzz of a central London destination, yet with a distinctly local feel. Here you’ll find a community of people from all walks of life, each bringing something different to a neighbourhood that’s cultured, creative and connected.",
      position: { x: 0, y: 1.16 }
    },
    caption: {
      label: "A MAJOR NEW DEVELOPMENT FOR ZONE 1",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/1-3.jpg",
    path: "/assets/images/gallery/1-3.jpg",
    position: {
      x: 4.7 + Start,
      y: 0.18
    },
    title: {
      label:
        "Folio Gardens is the exciting third phase to launch at Postmark, enhancing the already established phases with a brand new bustling public square at the heart of Farringdon, complete with landscaped gardens and a lively mix of shops, workspaces and cafés for the whole community to enjoy.",
      position: { x: 0, y: -0.1 }
    },
    caption: {
      label: "LANDSCAPED PUBLIC SQUARE",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/1-4.jpg",
    path: "/assets/images/gallery/1-4.jpg",
    position: {
      x: 7.2 + Start,
      y: 0
    },
    title: {
      label:
        "The landscaped public realm will be surrounded by 7,425sqft of retail and commercial spaces as part of Folio Gardens with an additional 6,000 sq ft added in the final phase of Postmark, Monograph Square.",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "LANDSCAPED PUBLIC SQUARE",
      position: { x: 0, y: 0 }
    }
  }
]

const TileData = {
  icon: TitleIcon,
  top: "auto",
  left: "5vw",
  bottom: "4vw",
  right: "auto",
  width: "43vw"
}

const FoliokGallery = () => <Gallery3D title={TileData} tiles={Tiles} length={9.7} />

export default FoliokGallery
